<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <!-- Hero Section -->
      <div class="container space-top-3 space-bottom-2">
        <div class="w-lg-80 text-center mx-lg-auto">
          <div class="mb-5 mb-md-11">
            <h2 class="display-4">{{content.title}}</h2>
            <p class="lead">
              {{content.subtitle}}
            </p>
          </div>
        </div>

        <!-- Gallery Section -->
        <div class="row mx-n2" v-if="sixImageList.length>0">
          <div class="w-100"></div>

          <div class="col-6 col-md px-2 mb-3 mb-md-0">
            <div
              class="h-250rem bg-img-hero"
              :style="'background-image: url('+getImgUrl(sixImageList[0])+');'"
              alt=""
            />
          </div>
          <div  class="col-md-4 d-none d-md-block px-2 mb-3 mb-md-0">
            <div
              class="h-250rem bg-img-hero"
              :style="'background-image: url('+getImgUrl(sixImageList[1])+');'"
              alt=""
            />
          </div>
          <div class="col-6 col-md px-2">
            <div
              class="h-250rem bg-img-hero"
              :style="'background-image: url('+getImgUrl(sixImageList[2])+');'"
              alt=""
            />
          </div>
        </div>
        <!-- End Gallery Section -->
      </div>
      <!-- End Hero Section -->

      <!-- Divider -->
      <div class="container">
        <div class="w-lg-100 mx-lg-auto">
          <hr class="my-0" />
        </div>
      </div>
      <!-- End Divider -->

      <div v-if="show" class="container space-1">
        <!-- Timeline -->
        <ul  class="step" v-for="item in colNum" :key="item.columnId" :style="devloplist[item.title].length == 0 ? 'display:none':''">
          <template v-if="devloplist[item.title].length>0">
            <h4 class="h3 space-1">{{item.title}}</h4>
            <li class="step-item" v-for="hs in devloplist[item.title]" :key="hs.contentId">
              <div class="step-content-wrapper">
                <span class="step-icon step-icon-sm step-icon-soft-primary"
                  ><i class="far fa-calendar-alt"></i
                ></span>
                <div class="step-content">
                  <span class="timeline-heading text-dark">{{getTime(hs.releaseTime)}}</span>
                  <p class="mb-0">{{hs.title}}</p>
                </div>
              </div>
            </li>
          </template>
          <!-- Timeline Item -->
          
        </ul>
        <!-- End Timeline -->
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js"; //1
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js"; //2

import "@/assets/vendor/font-awesome/css/all.min.css"; //12
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css"; //13
import "@/assets/css/theme.css"; //14
import "@/assets/vendor/hs-header/dist/hs-header.min.js"; //4
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js"; //5
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js"; //6
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js"; //7
import "@/assets/vendor/hs-show-animation/dist/hs-show-animation.min.js"; //8.
import "@/assets/vendor/jquery-validation/dist/jquery.validate.min.js"; // 9.
import AOS from "aos";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; //3

import "@/assets/js/hs.core.js"; //10
import "@/assets/js/hs.validation.js"; // 11.
import Header from "../components/header";
import Footer from "../components/footer";
import moment from 'moment'
import { getsy, getsycolumn, getsyres,getResouceInfo } from "../request/index";
export default {
  components: {
    Header,
    Footer,
  },
  data(){
    return{
      devloplist:{},
      content:{
        title:null,
        subtitle:null
      },
      imglist:{left:null,center:null,right:null,},
      colNum:[],
      show:false,
      sixImageList: [],
    }
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    $(document).ready(function () {
      console.log("aaa");
      //   console.log("ccccc",HSHeader)
      //   var header = new HSHeader($("#header")).init();
      console.log("bbb");

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of fancybox
      $(".js-fancybox").each(function () {
        var fancybox = $.HSCore.components.HSFancyBox.init($(this));
      });

      // initialization of circles
      $(".js-circle").each(function () {
        var circle = $.HSCore.components.HSCircles.init($(this));
      });

      //initialization of aos
      AOS.init({
        duration: 650,
        once: true,
      });
      // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) document.write('<script src="@/assets/vendor/polifills.js"><\/script>');
      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
      $(".js-counter").each(function () {
        var counter = new HSCounter($(this)).init();
      });
    });
  },
  created(){
    this.getFirst()
    getResouceInfo({ type: 1 }).then((res) => {
      if (res.data.content.length > 0) {
        this.sixImageList = res.data.content[0].fileId.split(",");
      }
    });
  },
  methods:{
    // 获取当前栏目
    getFirst(){
      getsycolumn(0).then(res=>{
        let arr = res.data;
        arr.forEach(item=>{
          if(item.title == "发展历程"){
            getsy(item.columnId).then(res=>{
              console.log(177,res)
              this.content = res.data.content[0]
            })
            getsycolumn(item.columnId).then(hs=>{
              let arr1 = hs.data
              this.colNum = hs.data.sort((a,b) =>{return b.title.substring(0,4) - a.title.substring(0,4)})
              arr1.forEach(ts=>{
                this.devloplist[ts.title] = []
                this.getContent(ts.title,ts.columnId)
              })
            })
          }
        })
      })
    },
    // 获取内容
    getContent(title,id){
      this.show =false
      getsy(id).then(res=>{
        if(title.length == 0){
          title = res.data.content
        }else{
          this.devloplist[title] = res.data.content.sort((a,b)=>{return b.releaseTime - a.releaseTime})
          setTimeout(()=>{
            this.show = true
          },200)
        }
        let arr = res.data.content
        arr.forEach(item=>{
          this.getSource(item.contentId)
        })
      })
    },
    // 获取内容资源资源
    getSource(id){
      getsyres(id).then(res=>{
        let arr = res.data
        if(arr && arr.length>0){
          arr.forEach(hs=>{this.imglist[hs.keystring] = hs.fileId})
        }
      })
    },
    // 图片地址
    getImgUrl(id){
      return process.env.NODE_URL + "api/files/getFileStream?fileId="+id
    },
    // 时间转换
    getTime(val){
        return moment(val).format('YYYY年MM月DD日')
    }
  }
};
</script>

<style scoped>

.display-4 {
  font-size: 3.5rem;
  font-weight: 600;
  line-height: 1.2;
}
.lead {
  font-size: 1.25rem;
  font-weight: 400;
  color: #677788;
}
.step h4 {
  font-size: 1.3125rem !important;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
  padding: 0 15px;
}
.step-content .text-dark {
  color: #1e2022 !important;
}
.mb-0 {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
.mb-2 {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
</style>


// WEBPACK FOOTER //
// src/view/history.vue